import { render, staticRenderFns } from "./ALiPay.vue?vue&type=template&id=57e6d24a&scoped=true"
import script from "./ALiPay.vue?vue&type=script&lang=js"
export * from "./ALiPay.vue?vue&type=script&lang=js"
import style0 from "./ALiPay.vue?vue&type=style&index=0&id=57e6d24a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e6d24a",
  null
  
)

export default component.exports